import React from 'react';
import { NotificationsPanel, PageHeader } from '@/components/common';

/** N1–N3, N5 on phones: the notifications list as its own page (tablet and desktop use the bell's panel). */
const NotificationsPage: React.FC = () => (
  <div className="tw-mx-auto tw-flex tw-w-full tw-max-w-[720px] tw-flex-col tw-gap-4">
    <PageHeader title="Notifications" back={{ to: '/customer/policies', label: 'Back' }} />
    <NotificationsPanel variant="page" />
  </div>
);

export default NotificationsPage;
